import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaClock, FaEuroSign } from "react-icons/fa";
import { tours } from "../data/tours";
import "./Tours.css";

import imgg1 from "../photos/tours_reg_silk_road.png";

const Tours = () => {

    return (
        <section className="tours-page">
            <div className="tours-header">

                <span className="tours-subtitle">
                    O‘zbekiston sayohatlari
                </span>

                <h1>
                    Bizning eksklyuziv turlarimiz
                </h1>

                <p>
                    Samarqand, Buxoro, Xiva va Buyuk Ipak yo‘li bo‘ylab
                    unutilmas sayohatlarni biz bilan kashf eting.
                </p>

            </div>
            <div className="custom-tour">

                <div className="custom-tour-left">

                    <span className="custom-tour-subtitle">
                        Tailor-Made Tours
                    </span>

                    <h2>
                        O'zingiz xohlagan sayohatni birgalikda yaratamiz
                    </h2>

                    <p>
                        Sizning qiziqishlaringiz, budjetingiz va sayohat rejangiz asosida
                        individual tur paketlarini tayyorlaymiz. Mehmonxona, transport,
                        professional gid va barcha xizmatlar sizning istagingizga mos
                        ravishda tashkil etiladi.
                    </p>

                    <Link to="/contact" className="custom-tour-btn">
                        Maxsus tur buyurtma qilish
                        <FaArrowRight />
                    </Link>

                </div>

                <div className="custom-tour-right">

                    <img
                        src={imgg1}
                        alt="Uzbekistan Tour"
                    />

                </div>

            </div>

            <div className="tour-stats">

                <div>
                    <h3>500+</h3>
                    <span>Happy Travelers</span>
                </div>

                <div>
                    <h3>50+</h3>
                    <span>Premium Tours</span>
                </div>

                <div>
                    <h3>24/7</h3>
                    <span>Support</span>
                </div>

            </div>





            <div className="tours-container">

                {tours.map((tour) => (

                    <article className="tour-card" key={tour.id}>


                        <div className="tour-image">

                            <img
                                src={tour.gallery[1] || imgg1}
                                alt={tour.title}
                            />


                            <div className="tour-overlay">

                                <span>
                                    {tour.duration}
                                </span>

                            </div>

                        </div>



                        <div className="tour-content">


                            <h2>
                                {tour.title}
                            </h2>



                            <p className="tour-description">

                                {tour.description.length > 170
                                    ? tour.description.substring(0, 170) + "..."
                                    : tour.description
                                }

                            </p>



                            <div className="tour-info">


                                <div>

                                    <FaClock />

                                    <span>
                                        {tour.duration}
                                    </span>

                                </div>



                                <div>

                                    <FaEuroSign />

                                    <span>
                                        {tour.price}
                                    </span>

                                </div>


                            </div>



                            <Link
                                to={`/tours/${tour.id}`}
                                className="tour-btn"
                            >

                                Batafsil ko‘rish

                                <FaArrowRight />

                            </Link>



                        </div>


                    </article>


                ))}


            </div>


        </section>
    );
};


export default Tours;